import { UserIdentification } from "./userIdentifications";
import { DateHelper } from "../../helpers/DateHelper";

export class User {
    id: number;
    email: string;
    alternativeEmail: string;
    password: string;
    firstName: string;
    middleName: string;
    lastName: string;
    nickname: string;
    userRole: string;
    birthDate: string = DateHelper.getDateNowString(); //dateString
    dateEmployed: string = DateHelper.getDateNowString(); //dateString
    employeeRole: string;
    addressLine1: string;
    addressLine2: string;
    country: string;
    state: string;
    city: string;
    contactNumber1: string;
    contactNumber2: string;
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
    identifications: UserIdentification[] = [];
    fullName: string;
    isActive: boolean;
    salaryType: string;
}


// WEBPACK FOOTER //
// ./src/app/models/users/User.ts